import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

/**
 * Wraps a route with both authentication AND role checks.
 * - Not authenticated → /
 * - Authenticated but wrong role → /access-denied
 * - Authenticated and correct role → renders children
 *
 * Usage: <RoleProtectedRoute allowedRoles={['Gerente']}><MyPage /></RoleProtectedRoute>
 */
function RoleProtectedRoute({ children, allowedRoles }) {
  // 'loading' | 'allowed' | 'denied' | 'unauthenticated'
  const [state, setState] = useState('loading');

  useEffect(() => {
    async function check() {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        setState('unauthenticated');
        return;
      }

      const { data } = await supabase
        .from('users')
        .select('roles(name)')
        .eq('id', session.user.id)
        .single();

      const role = data?.roles?.name;
      setState(allowedRoles.includes(role) ? 'allowed' : 'denied');
    }
    check();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (state === 'loading') return null;
  if (state === 'unauthenticated') return <Navigate to="/" replace />;
  if (state === 'denied') return <Navigate to="/access-denied" replace />;
  return children;
}

export default RoleProtectedRoute;
